import { MY_CLEANINGS_ENDPOINT } from "@config/endpoints";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";

import { ASYNC_ACTION_TYPES } from "@services/FetchFacade";
import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";
import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";

import { asyncActionCreator } from "@app/services/AsyncActionCreator";

import { SaveOption } from "./userOptions.typings";

const actionCreator = new ReduxActionNameCreator("user options");

// Actions
export const FETCH_OPTIONS: string = actionCreator.make("fetch options");
export const SAVE_OPTION: string = actionCreator.make("save option");

// Action creators
export const fetchOptions =
  () =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const url = `${MY_CLEANINGS_ENDPOINT}/options`;
    const action = await asyncActionCreator({
      url,
      action: FETCH_OPTIONS,
    });

    return dispatch(action);
  };

export const saveOption =
  (payload: SaveOption) =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const url = `${MY_CLEANINGS_ENDPOINT}/options`;

    const action = await asyncActionCreator({
      action: SAVE_OPTION,
      body: {
        key: payload.option,
        value: payload.value,
      },
      params: {
        ...payload,
      },
      method: ASYNC_ACTION_TYPES.POST,
      url,
    });

    return dispatch(action);
  };
